import React from 'react';
import {View, ScrollView, Image, TouchableOpacity} from 'react-native';
import Icon from 'react-native-vector-icons/MaterialCommunityIcons';
import {styles} from './styles';
import CCText from '@/Atoms/CCText';
import {FontSizes, vs} from '@/Utils/Dimensions';
import CCColors from '@/Utils/CCColors';
import Spacer from '@/Atoms/Spacer';
import CCButton from '@/Atoms/CCButton';
import {useNavigation} from '@react-navigation/native';
import {ScreenName} from '@/navigators/StackConstants';
import {useMediaQuery} from '@/Hooks/useMediaQuery/useMediaQuery';

const BeginnerDashboard = () => {
  const navigation = useNavigation();
  const {isMobileOrTab} = useMediaQuery();

  return (
    <View style={{flex: 1, padding: 10, flexBasis: '100%'}}>
      <ScrollView contentContainerStyle={styles.container}>
        <CCText
          fontSize={FontSizes[20]}
          color={CCColors?.TextColor?.Dark}
          style={{fontWeight: '500'}}>
          Start your learning
        </CCText>
        <Spacer spacing={20} />
        <View style={!isMobileOrTab ? styles.firstRow : undefined}>
          <View
            style={[
              styles.card,
              styles.largeCard,
              styles.borderColor,
              isMobileOrTab && {width: '100%', flexDirection: 'row'},
            ]}>
            <View style={styles.cardContent}>
              <View>
                <CCText
                  fontSize={FontSizes[isMobileOrTab ? 14 : 18]}
                  color={CCColors?.TextColor?.Dark}
                  style={styles.title}>
                  Play a game
                </CCText>
                <View style={styles.row}>
                  <Image
                    source={require('@/Assets/Images/Svgs/BeginnerDashboard/pawnIcon.svg')}
                    style={styles.pawnIcon}
                    resizeMode="contain"
                  />
                  <CCText
                    fontSize={FontSizes[isMobileOrTab ? 12 : 14]}
                    color={CCColors?.TextColor?.Primary}
                    style={styles.subText}>
                    2K played
                  </CCText>
                </View>
              </View>
              <CCButton
                style={styles.primaryButton}
                contentContainerStyle={{
                  paddingVertical: vs(isMobileOrTab ? 8 : 14),
                  borderRadius: vs(32),
                }}
                onPress={() => navigation.navigate(ScreenName?.PlayChess)}
                titleStyle={{fontSize: 16, color: CCColors?.TextColor?.Dark}}>
                Play Now
              </CCButton>
            </View>
            <Image
              source={require('@/Assets/Images/Svgs/BeginnerDashboard/PlayAGame.svg')}
              style={styles.largeImage}
              resizeMode="cover"
            />
          </View>
          {!isMobileOrTab && (
            <>
              <View style={[styles.card, styles.smallCard]}>
                <Image
                  source={require('@/Assets/Images/Svgs/BeginnerDashboard/Intersect.svg')}
                  style={styles.backgroundTopImage}
                  resizeMode="cover"
                />
                <Image
                  source={require('@/Assets/Images/Svgs/BeginnerDashboard/IntersectPattern.svg')}
                  style={styles.backgroundPattern}
                  resizeMode="contain"
                />
                <Image
                  source={require('@/Assets/Images/Svgs/BeginnerDashboard/FindSquare.svg')}
                  style={styles.smallCardImage}
                  resizeMode="contain"
                />
                <CCText
                  fontSize={FontSizes[isMobileOrTab ? 14 : 18]}
                  color={CCColors?.TextColor?.Dark}
                  style={styles.titleSmall}>
                  Find a square on the board
                </CCText>
                <View
                  style={{
                    alignItems: 'center',
                    display: 'flex',
                    flexDirection: 'row',
                    gap: 8,
                    marginBottom: 32,
                  }}>
                  <View style={styles.subRow}>
                    <Icon
                      name="view-grid-outline"
                      size={20}
                      color={CCColors?.TextColor?.Primary}
                    />
                    <CCText
                      fontSize={FontSizes[14]}
                      color={CCColors?.TextColor?.Primary}
                      style={styles.subText}>
                      2K solves
                    </CCText>
                  </View>
                  <TouchableOpacity
                    onPress={() =>
                      navigation.navigate(ScreenName?.Visualisation)
                    }
                    style={styles.iconButton}>
                    <Icon
                      name="arrow-right"
                      size={24}
                      color={CCColors?.TextColor?.Dark}
                    />
                  </TouchableOpacity>
                </View>
              </View>
              <View style={[styles.card, styles.smallCard]}>
                <Image
                  source={require('@/Assets/Images/Svgs/BeginnerDashboard/Intersect.svg')}
                  style={styles.backgroundTopImage}
                  resizeMode="cover"
                />
                <Image
                  source={require('@/Assets/Images/Svgs/BeginnerDashboard/IntersectPattern.svg')}
                  style={styles.backgroundPattern}
                  resizeMode="contain"
                />
                <Image
                  source={require('@/Assets/Images/Svgs/BeginnerDashboard/PracticePosition.svg')}
                  style={styles.smallCardImage}
                  resizeMode="contain"
                />
                <CCText
                  fontSize={FontSizes[isMobileOrTab ? 14 : 18]}
                  color={CCColors?.TextColor?.Dark}
                  style={styles.titleSmall}>
                  Practice a position
                </CCText>
                <View
                  style={{
                    alignItems: 'center',
                    display: 'flex',
                    flexDirection: 'row',
                    gap: 8,
                    marginBottom: 32,
                  }}>
                  <View style={styles.subRow}>
                    <Icon
                      name="view-grid-outline"
                      size={20}
                      color={CCColors?.TextColor?.Primary}
                    />
                    <CCText
                      fontSize={FontSizes[14]}
                      color={CCColors?.TextColor?.Primary}
                      style={styles.subText}>
                      2K solves
                    </CCText>
                  </View>
                  <TouchableOpacity
                    onPress={() => navigation.navigate(ScreenName?.Puzzles)}
                    style={styles.iconButton}>
                    <Icon
                      name="arrow-right"
                      size={24}
                      color={CCColors?.TextColor?.Dark}
                    />
                  </TouchableOpacity>
                </View>
              </View>
            </>
          )}
        </View>
        <View style={!isMobileOrTab ? styles.secondRow : undefined}>
          <View
            style={[
              styles.card,
              styles.largeCard,
              styles.borderColor,
              isMobileOrTab && {width: '100%', flexDirection: 'row'},
            ]}>
            <View style={styles.cardContent}>
              <View>
                <CCText
                  fontSize={FontSizes[isMobileOrTab ? 14 : 18]}
                  color={CCColors?.TextColor?.Dark}
                  style={styles.title}>
                  Learning Roadmap
                </CCText>
                <View style={styles.row}>
                  <Icon
                    name="book-open-outline"
                    size={isMobileOrTab ? 16 : 20}
                    color={CCColors?.TextColor?.Primary}
                  />
                  <CCText
                    fontSize={FontSizes[isMobileOrTab ? 12 : 14]}
                    color={CCColors?.TextColor?.Primary}
                    style={styles.subText}>
                    2K Learners
                  </CCText>
                </View>
              </View>
              <CCButton
                onPress={() => navigation.navigate(ScreenName?.Courses)}
                style={styles.primaryButton}
                contentContainerStyle={{
                  paddingVertical: vs(isMobileOrTab ? 8 : 14),
                  borderRadius: vs(32),
                }}
                titleStyle={{fontSize: 16, color: CCColors?.TextColor?.Dark}}>
                Learn Now
              </CCButton>
            </View>
            <Image
              source={require('@/Assets/Images/Svgs/BeginnerDashboard/LearningRoadmap.svg')}
              style={styles.largeImage}
              resizeMode="cover"
            />
          </View>
          {isMobileOrTab && (
            <View
              style={{
                flexDirection: 'row',
                justifyContent: 'space-between',
                gap: 8,
              }}>
              <View style={[styles.card, styles.smallCard, {flex: 1}]}>
                <Image
                  source={require('@/Assets/Images/Svgs/BeginnerDashboard/Intersect.svg')}
                  style={styles.backgroundTopImage}
                  resizeMode="cover"
                />
                <Image
                  source={require('@/Assets/Images/Svgs/BeginnerDashboard/IntersectPattern.svg')}
                  style={styles.backgroundPattern}
                  resizeMode="contain"
                />
                <Image
                  source={require('@/Assets/Images/Svgs/BeginnerDashboard/FindSquare.svg')}
                  style={styles.smallCardImage}
                  resizeMode="contain"
                />
                <CCText
                  fontSize={FontSizes[14]}
                  color={CCColors?.TextColor?.Dark}
                  style={styles.titleSmall}>
                  Find a square on the board
                </CCText>
                <View
                  style={{
                    alignItems: 'center',
                    display: 'flex',
                    flexDirection: 'row',
                    gap: 8,
                    marginTop: 10,
                  }}>
                  <View style={styles.subRow}>
                    <Icon
                      name="view-grid-outline"
                      size={16}
                      color={CCColors?.TextColor?.Primary}
                    />
                    <CCText
                      fontSize={FontSizes[12]}
                      color={CCColors?.TextColor?.Primary}
                      style={styles.subText}>
                      2K solves
                    </CCText>
                  </View>
                  <TouchableOpacity
                    onPress={() =>
                      navigation.navigate(ScreenName?.Visualisation)
                    }
                    style={styles.iconButton}>
                    <Icon
                      name="arrow-right"
                      size={16}
                      color={CCColors?.TextColor?.Dark}
                    />
                  </TouchableOpacity>
                </View>
              </View>
              <View style={[styles.card, styles.smallCard, {flex: 1}]}>
                <Image
                  source={require('@/Assets/Images/Svgs/BeginnerDashboard/Intersect.svg')}
                  style={styles.backgroundTopImage}
                  resizeMode="cover"
                />
                <Image
                  source={require('@/Assets/Images/Svgs/BeginnerDashboard/IntersectPattern.svg')}
                  style={styles.backgroundPattern}
                  resizeMode="contain"
                />
                <Image
                  source={require('@/Assets/Images/Svgs/BeginnerDashboard/PracticePosition.svg')}
                  style={styles.smallCardImage}
                  resizeMode="contain"
                />
                <CCText
                  fontSize={FontSizes[14]}
                  color={CCColors?.TextColor?.Dark}
                  style={styles.titleSmall}>
                  Practice a position
                </CCText>
                <View
                  style={{
                    alignItems: 'center',
                    display: 'flex',
                    flexDirection: 'row',
                    gap: 8,
                    marginTop: 10,
                  }}>
                  <View style={styles.subRow}>
                    <Icon
                      name="view-grid-outline"
                      size={16}
                      color={CCColors?.TextColor?.Primary}
                    />
                    <CCText
                      fontSize={FontSizes[12]}
                      color={CCColors?.TextColor?.Primary}
                      style={styles.subText}>
                      2K solves
                    </CCText>
                  </View>
                  <TouchableOpacity
                    onPress={() => navigation.navigate(ScreenName?.Puzzles)}
                    style={styles.iconButton}>
                    <Icon
                      name="arrow-right"
                      size={16}
                      color={CCColors?.TextColor?.Dark}
                    />
                  </TouchableOpacity>
                </View>
              </View>
            </View>
          )}
          <View
            style={[
              styles.card,
              styles.largeCard,
              isMobileOrTab && {width: '100%', flexDirection: 'row'},
            ]}>
            <View style={styles.cardContent}>
              <View>
                <CCText
                  fontSize={FontSizes[isMobileOrTab ? 14 : 18]}
                  color={CCColors?.TextColor?.Dark}
                  style={styles.title}>
                  Calculation Trainer
                </CCText>
                <View style={styles.row}>
                  <Icon
                    name="puzzle-outline"
                    size={isMobileOrTab ? 16 : 20}
                    color={CCColors?.TextColor?.Primary}
                  />
                  <CCText
                    fontSize={FontSizes[isMobileOrTab ? 12 : 14]}
                    color={CCColors?.TextColor?.Primary}
                    style={styles.subText}>
                    2K solves
                  </CCText>
                </View>
              </View>
              <CCButton
                onPress={() =>
                  navigation.navigate(ScreenName?.Visualisation, {
                    selected: 'calculation',
                  })
                }
                style={styles.primaryButton}
                contentContainerStyle={{
                  paddingVertical: vs(isMobileOrTab ? 8 : 14),
                  borderRadius: vs(32),
                }}
                titleStyle={{fontSize: 16, color: CCColors?.TextColor?.Dark}}>
                Solve Now
              </CCButton>
            </View>
            <Image
              source={require('@/Assets/Images/Svgs/BeginnerDashboard/Chessboard.svg')}
              style={styles.largeImage}
              resizeMode="contain"
            />
          </View>
        </View>
        <Image
          source={require('@/Assets/Images/Svgs/BeginnerDashboard/Background.svg')}
          style={styles.backgroundImage}
          resizeMode="cover"
        />
      </ScrollView>
    </View>
  );
};

export default BeginnerDashboard;
